// export.js — client-side CSV + plain-text report downloads (the Analytics.jsx
// ReportsCard idiom: build a Blob, click a temporary anchor). No server round-trip.

function download(filename, text, mime) {
  const blob = new Blob([text], { type: mime + ';charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

function csvCell(v) {
  if (v === null || v === undefined) return '';
  const s = String(v);
  return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
}

// rows: array of objects; columns: [{ key, label }]. Returns nothing — downloads.
export function downloadCsv(filename, columns, rows) {
  const head = columns.map((c) => csvCell(c.label)).join(',');
  const body = rows.map((r) => columns.map((c) => csvCell(r[c.key])).join(',')).join('\n');
  download(filename, head + '\n' + body + '\n', 'text/csv');
}

// A plain-text report: a title, a metadata block, then labelled sections. Each
// section is either { lines: [...] } or { columns, rows } (rendered as a table).
export function downloadTxtReport(filename, { title, meta = [], sections = [] }) {
  const out = [];
  out.push(title);
  out.push('='.repeat(title.length));
  out.push('');
  for (const m of meta) out.push(m);
  if (meta.length) out.push('');
  for (const s of sections) {
    if (s.heading) { out.push(s.heading); out.push('-'.repeat(s.heading.length)); }
    if (s.lines) for (const l of s.lines) out.push(l);
    if (s.columns && s.rows) {
      const cols = s.columns;
      const widths = cols.map((c) =>
        Math.max(c.label.length, ...s.rows.map((r) => String(r[c.key] ?? '').length)));
      const fmtRow = (vals) => vals.map((v, i) => String(v ?? '').padEnd(widths[i])).join('  ');
      out.push(fmtRow(cols.map((c) => c.label)));
      out.push(widths.map((w) => '-'.repeat(w)).join('  '));
      for (const r of s.rows) out.push(fmtRow(cols.map((c) => r[c.key])));
    }
    out.push('');
  }
  download(filename, out.join('\n'), 'text/plain');
}
